import { render, staticRenderFns } from "./spacer-h16.vue?vue&type=template&id=04bca518&scoped=true&"
import script from "./spacer-h16.vue?vue&type=script&lang=js&"
export * from "./spacer-h16.vue?vue&type=script&lang=js&"
import style0 from "./spacer-h16.vue?vue&type=style&index=0&id=04bca518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bca518",
  null
  
)

export default component.exports